import React, { useEffect, useRef, useState } from "react";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import ApiController from "../../controller/ApiController";
import { langState, langText } from "../../recoil/lang";
import { showKeyboardState } from "../../recoil/showKeyboard";
import { RequestReviewType } from "../../recoil/socket";
import "../../styles/CustomModal.css";
import LogController from "../../controller/LogController";

const RatingModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  ratingInfo: RequestReviewType | null;
  setRatingInfo: (ratingInfo: RequestReviewType | null) => void;
}) => {
  const onCloseModal = () => {
    oProps.setVisible(false);
    oProps.setRatingInfo(null);
    LogController.click({
      path: "RatingModal",
      params: "rating",
      params2: "사용자가 리뷰 모달 닫음",
    });
  };

  useEffect(() => {
    if (oProps.isVisible) {
      LogController.event({
        path: "RatingModal",
        params: "rating",
        params2: "리뷰 모달 열림",
      });
    }
  }, [oProps.isVisible]);

  const textareaRef = useRef<any>(null);

  const [lang, setLang] = useRecoilState<number>(langState);
  const [foodRating, setFoodRating] = useState<number>(5);
  const [deliveryRating, setDeliveryRating] = useState<number>(5);
  const [review, setReview] = useState<string>("");
  const [showKeyboard, setShowKeyboard] = useRecoilState(showKeyboardState);

  // API 호출
  const sendReview = async () => {
    try {
      if (oProps.ratingInfo !== null) {
        const oParams = {
          order_id: oProps.ratingInfo.order_id,
          order_seq: oProps.ratingInfo.order_seq,
          store_id: oProps.ratingInfo.store_id,
          parent_store_id: oProps.ratingInfo.parent_store_id,
          food_score: foodRating,
          delivery_score: deliveryRating,
          content: review,
        };
        const oRes: any = await ApiController.order.setReview(oParams);

        if (oRes && oRes.data) {
          console.log("setReview", oRes.data);
          if (oRes.data.success) {
            oProps.setRatingInfo(null);
            LogController.event({
              path: "RatingModal",
              params: "rating",
              params2: `${oProps.ratingInfo.order_id} 주문 리뷰 등록 완료`,
            });
          } else {
            LogController.api({
              path: "RatingModal",
              params: "rating",
              params2: `/order/setReview ${oProps.ratingInfo.order_id} 주문 리뷰 실패`,
            });
          }
        }
      }
      oProps.setVisible(false);
    } catch (err) {
      console.log("err-->", err);
    }
  };

  useEffect(() => {
    setDeliveryRating(5);
    setFoodRating(5);
    setReview("");
  }, [oProps.isVisible]);

  useEffect(() => {
    setReview(showKeyboard.input);
  }, [showKeyboard]);

  useEffect(() => {
    const textarea = textareaRef.current;

    if (textarea) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
  }, [review]);

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "optionCustomOverlay",
        modal: "ratingModal",
      }}
      closeOnOverlayClick={false}
      showCloseIcon={true}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <div className="centerWrap">
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check_green.svg`}
              alt="ic"
            />
            <p className="titleFont">{langText.ratingModal_title[lang]}</p>
          </div>
          <div className="ratingBox">
            <div className="title">
              {langText.ratingModal_title_rating[lang]}
            </div>
            <div className="content">
              <div className="row">
                <p>{langText.ratingModal_delivery_rating[lang]}</p>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star.svg`}
                  alt="ic"
                  onClick={() => setDeliveryRating(1)}
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    deliveryRating < 2 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setDeliveryRating(2)}
                  alt="ic"
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    deliveryRating < 3 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setDeliveryRating(3)}
                  alt="ic"
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    deliveryRating < 4 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setDeliveryRating(4)}
                  alt="ic"
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    deliveryRating < 5 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setDeliveryRating(5)}
                  alt="ic"
                />
              </div>
              <div className="row">
                <p>{langText.ratingModal_food_rating[lang]}</p>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star.svg`}
                  alt="ic"
                  onClick={() => setFoodRating(1)}
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    foodRating < 2 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setFoodRating(2)}
                  alt="ic"
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    foodRating < 3 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setFoodRating(3)}
                  alt="ic"
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    foodRating < 4 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setFoodRating(4)}
                  alt="ic"
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    foodRating < 5 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setFoodRating(5)}
                  alt="ic"
                />
              </div>
              {lang === 0 ? (
                <textarea
                  ref={textareaRef}
                  value={review}
                  placeholder={langText.ratingModal_placeholder[lang]}
                  autoFocus={false}
                  onChange={(e) => setReview(e.target.value)}
                />
              ) : (
                <div
                  ref={textareaRef}
                  onClick={() =>
                    setShowKeyboard((prev) => ({
                      ...prev,
                      showKeyboard: true,
                      input: review,
                    }))
                  }
                  className="textarea"
                >
                  {review || langText.conciergeModal_placeholder[lang]}
                </div>
              )}
            </div>
          </div>

          <div className="confirmButton" onClick={sendReview}>
            {langText.button_confirm[lang]}
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default RatingModal;

const Style = styled.div`
  .modal {
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 8% 6%;
    width: 100%;
    height: 100%;
  }

  .centerWrap {
    height: 22%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .titleFont {
    font-size: 20px;
    line-height: 28px;
    font-weight: 400;
    color: #000000;
    text-align: center;
    margin: 0 0;
  }

  .row {
    padding-bottom: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ratingBox {
    width: 90%;
    height: 50%;
    margin-bottom: 20px;

    .title {
      background: #4d4d4d;
      border: 1px solid #4d4d4d;
      color: #ffffff;
      font-size: 18px;
      line-height: 40px;
      font-weight: 400;
      text-align: center;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    .content {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      border: 1px solid #d1d1d1;
      padding: 14px 18px;
      height: 90%;
      text-align: center;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;

      p {
        width: 30%;
        color: #000000;
        font-size: 18px;
        line-height: 36px;
        font-weight: 400;
        margin: 0 0;
        padding-right: 8px;
      }
    }

    textarea,
    .textarea {
      margin: 20px 0;
      display: flex;
      align-items: center;
      width: 100%;
      height: 40%;
      background: #f3f3f3;
      border: none;
      padding: 12px 16px;
      border-radius: 10px;
      font-size: 16px;
      font-weight: 300;
      text-align: left;
      max-height: 50px;
      overflow-y: auto;
    }
  }

  .confirmButton {
    width: 90%;
    padding: 16px;
    background: #4dd2ae;
    font-size: 24px;
    line-height: 32px;
    border-radius: 10px;
    color: #ffffff;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
  }
`;
